import {callLambda} from '@/lib/api/lambda';

/**
 * 取得產品現在是否正在更新中
 * @param {String} code 棋院代號
 * @returns {Array} Array
 */
export function getSystemState() {
  return callLambda({
    category: 'maintenance',
    method: 'get',
    apiName: 'state',
  }).then((res) => {
    return res.data;
  });
}

/**
 * 取得產品現在是否正在更新中
 * @param {String} code 棋院代號
 * @returns {Array} Array
 */
export async function getServerTime() {
  try {
    const res = await callLambda({
      category: 'maintenance',
      method: 'get',
      apiName: 'time',
    });
    return Number(res.data);
  } catch (e) {
    console.error('getServerTime error', e);
    return Date.now();
  }
}

/**
 * getSignedUrl
 * @param {String} key key
 * @param {String} method 方法
 * @returns {Array} Array
 */
export function getSignedUrl({key, method}) {
  return callLambda({
    category: 'maintenance',
    method: 'get',
    apiName: 'files/signedUrl',
    params: {
      key,
      method,
    },
  }).then((res) => {
    return res.data?.url;
  });
}

export default {
  getServerTime,
  getSystemState,
  getSignedUrl,
};
